import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';

import { Banco } from '../_models/banco/banco';
import { Observable } from 'rxjs';

import { BancoResponse } from '../_models/response/bancoResponse';


export const HTTP_OPTIONS = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Access-Control-Allow-Credentials' : 'true',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, DELETE, PUT, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
  })
};

@Injectable({ providedIn: 'root' })
export class BancoService {


  constructor(private http: HttpClient) { }

  getAllBancoTodos() {
     return this.http.get<any>(`${environment.authorizedUrls.bsCobrancaUrl}/banco`);
  }

  inserir(banco: Banco): Observable<BancoResponse> {
    return this.http.post<BancoResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/banco/incluir`, {
      banco
    });
  }

  atualizar(banco: Banco): Observable<BancoResponse> {
     return this.http.post<BancoResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/banco/atualizar`, {
      banco
    });
  }

  deletar(banco: Banco): Observable<BancoResponse> {
    return this.http.post<BancoResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/banco/excluir`, {
      banco
    });
  }

}
